import { t } from "./to-integer-or-infinity.js";
var n = Math.min,
  r = function r(_r) {
    return _r > 0 ? n(t(_r), 9007199254740991) : 0;
  };
export { r as t };